var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcArrowChevronDownDark = function SvgIcArrowChevronDownDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ic-arrow-chevron-down-dark_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.987 11.21-5.35-5.36.7-.7 4.65 4.64 4.65-4.64.7.7-5.35 5.36z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ic-arrow-chevron-down-dark_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.986)",
    d: "M0 0h16v16H0z"
  })))));
};
export { SvgIcArrowChevronDownDark as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNyAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxnIGNsaXAtcGF0aD0idXJsKCM4c3hzOXdmZmlhKSI+CiAgICAgICAgPHBhdGggZD0ibTguOTg3IDExLjIxLTUuMzUtNS4zNi43LS43IDQuNjUgNC42NCA0LjY1LTQuNjQuNy43LTUuMzUgNS4zNnoiIGZpbGw9IiNmZmYiLz4KICAgIDwvZz4KICAgIDxkZWZzPgogICAgICAgIDxjbGlwUGF0aCBpZD0iOHN4czl3ZmZpYSI+CiAgICAgICAgICAgIDxwYXRoIGZpbGw9IiNmZmYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC45ODYpIiBkPSJNMCAwaDE2djE2SDB6Ii8+CiAgICAgICAgPC9jbGlwUGF0aD4KICAgIDwvZGVmcz4KPC9zdmc+Cg==";